import type { BootstrapResponse } from "@/lib/bootstrap-types";

export function isPlatformOwnerBootstrapContext(
  bootstrap: BootstrapResponse,
): boolean {
  return (
    bootstrap.permissions.security_role === "platform_admin" &&
    bootstrap.active_organization?.org_type === "platform_owner"
  );
}
